import React from 'react';
import KnotWatermark from '../illustrations/KnotWatermark';

const characteristics = [
  {
    title: 'Intervenciones activas y aplicables',
    description: 'Con ejercicios y tareas con sentido entre sesiones.',
  },
  {
    title: 'Adaptación total a cada persona',
    description: 'A su ritmo, su historia y su forma de expresarse.',
  },
  {
    title: 'Espacio seguro y afirmativo',
    description: 'Especialmente para personas LGTBIQA+ y desde perspectiva de género.',
  },
  {
    title: 'Más allá de reducir síntomas',
    description: 'No buscamos solo que "se te pase", sino que puedas construir una vida con mayor calma, libertad y coherencia.',
  },
];

export default function Methodology() {
  return (
    <section id="metodologia" className="section-padding bg-white relative overflow-hidden">
      <KnotWatermark position="top-right" />
      <div className="container-narrow relative">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-forest)] opacity-70 mb-4 uppercase">
              Cómo trabajamos
            </span>
            <h2 className="mb-6">Nuestra metodología</h2>
          </div>

          <div className="space-y-5 text-[var(--color-inerva-text-light)] mb-12">
            <p>
              Las sesiones tienen un enfoque contextual y práctico: buscamos entender qué mantiene el malestar
              en la vida cotidiana y qué necesitas para avanzar hacia una vida más plena.
            </p>
            <p>
              Trabajamos con terapias de tercera generación, que nos ayudan a entender y manejar mejor pensamientos y emociones difíciles sin luchar contra ellos. Utilizamos herramientas como la Terapia de Aceptación y Compromiso (ACT), que enseñan a tratarse con más amabilidad, a reducir la autoexigencia y a centrarse en lo que es importante para cada persona, incluso cuando hay malestar, favoreciendo así el bienestar emocional y el autocuidado.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div className="grid sm:grid-cols-2 gap-6">
              {characteristics.map((c, i) => (
                <div key={i} className="bg-[var(--color-inerva-cream)] rounded-[var(--radius-xl)] p-6">
                  <div className="w-10 h-10 rounded-full bg-[var(--color-inerva-forest)] text-white flex items-center justify-center text-lg font-serif mb-4">
                    {i + 1}
                  </div>
                  <h3 className="text-lg mb-2 font-serif">{c.title}</h3>
                  <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">{c.description}</p>
                </div>
              ))}
            </div>
            <div className="hidden lg:block">
              <video
                autoPlay
                loop
                muted
                playsInline
                poster="/assets/metodologia-poster.jpg"
                className="w-full h-auto rounded-[var(--radius-xl)] object-cover"
              >
                <source src="/assets/metodologia-video.mp4" type="video/mp4" />
                <source src="/assets/metodologia-video.webm" type="video/webm" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
